import { render, staticRenderFns } from "./CardLocation.vue?vue&type=template&id=363c9568"
import script from "./CardLocation.vue?vue&type=script&lang=js"
export * from "./CardLocation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports